<script lang="ts">
    import {onDestroy, onMount, tick} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import KpLoadablePageContainer from 'shared/layouts/KpLoadablePageContainer.svelte';

    export let pageClass = '';
    export let loading: boolean;
    export let loadError: boolean;
    export let loadingLabel: string;
    export let loadErrorLabel: string;

    export let printMode = false;
    let printModeMediaQuery: MediaQueryList;

    onMount(() => {
        // Print mode detection
        window.addEventListener('beforeprint', handleBeforePrint);
        window.addEventListener('afterprint', handleAfterPrint);

        if (window.matchMedia) {
            printModeMediaQuery = window.matchMedia('print');
            printModeMediaQuery.addEventListener('change', handlePrintMediaQueryChange);
            return;
        }
    });

    onDestroy(() => {
        window.removeEventListener('beforeprint', handleBeforePrint);
        window.removeEventListener('afterprint', handleAfterPrint);

        if (exists(printModeMediaQuery)) {
            printModeMediaQuery.removeEventListener('change', handlePrintMediaQueryChange);
        }
    });

    const handlePrintMediaQueryChange = (event: MediaQueryListEvent) => {
        if (event.matches) {
            handleBeforePrint();
        } else {
            handleAfterPrint();
        }
    }

    export const handlePrint = () => {
        handleBeforePrint();
        tick().then(() => {
            window.print();
        });
    }

    const handleBeforePrint = () => {
        printMode = true;
    }

    const handleAfterPrint = () => {
        printMode = false;
    }
</script>

<KpLoadablePageContainer {pageClass}
                         {loading}
                         {loadError}
                         {loadErrorLabel}
                         {loadingLabel}
                         loaderType="line">

    <slot {printMode} {handlePrint}/>
</KpLoadablePageContainer>